export const kinderConnectCaptureSettingsSearchInputE2eId = 'kinder-connect-capture-settings-search-input';
export const kinderConnectCaptureSettingsOnlyEnabledFilterE2eId = 'kinder-connect-capture-settings-only-enabled-filter';
export const kinderConnectCaptureSettingsChildToggleE2eClass = 'kinder-connect-capture-settings-child-toggle';
export const kinderConnectCaptureSettingsEmptyStateE2eId = 'kinder-connect-capture-settings-empty-state';
export const kinderConnectCaptureSettingsErrorStateE2eId = 'kinder-connect-capture-settings-error-state';
